import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {t} from 'i18next';

import styles from './ProductRoadmap.module.css';

export const ProductRoadmapEmptyState = ({timeframe}: {timeframe: string}) => (
  <Box className={styles.productRoadmapState} role="status">
    <Text isBold>{t('product_roadmap_empty_title')}</Text>
    <Text color="subtle">{t('product_roadmap_empty_body', {timeframe})}</Text>
  </Box>
);
